import React from 'react';
import Navbar from '../navbar/navbar';
import { Container } from 'react-bootstrap';
import Main from '../main/main';
import Footer from '../footer/footer';
import ConsentForm from '../consentForm/ConsentForm';
import '../sidebar/sidebar.scss';
import { useLocation } from 'react-router-dom';
import ProcessHubNavBar from '../processHub/processHubNavbar/ProcessHubNavBar';
import MarketingHubNavBar from '../marketingHub/marketingHubNavbar/MarketingHubNavBar';
import { MarketingHubRouteKeys, ProcessHubRouteKeys, ResourcePulseHubRouteKeys, PeopleHubRouteKeys, ContractsHubRouteKeys, TalentTransformationalHubRouteKeys, PracticeHubRouteKeys, FlipHubRouteKeys ,ImmigrationHubRouteKeys, AdminHubRouteKeys } from '../../containers/routes/route-keys';
import ResourcePulseHubNavBar from '../resourcePulseHubNavbar/ResourcePulseHubNavBar';
import PeopleHubNavigationbar from '../peoplehubnavbar/peoplehubnavbar';
import ChatbotNew from "../../components/chatbotnew/ChatBot";
import TalentTransformationalHubNavBar from '../learningLounge/talentTransformationalHubNavBar/TalentTransformationalHubNavBar';
import PracticeHubNavbar from '../practiceHub/practiceHubNavbar/PracticeHubNavbar';
import FlipHubNavBar from '../FlipHub/FlipHubNavBar';
import ContractsHubNavBar from '../contractsHub/ContractsHubNavBar';
import AdminHubNavBar from '../adminHub/AdminHubNavBar';
import ImmigrationHubNavBar from '../immigrationHub/immigrationHubNavBar/ImmigrationHubNavBar'

export default function Layout({ children }) {
    const location = useLocation();
    const isProcessHubRoute = Object.values(ProcessHubRouteKeys).includes(location?.pathname);
    const isMarketingHubRoute = Object.values(MarketingHubRouteKeys).includes(location?.pathname);
    const isResourcePulseHubRoute = Object.values(ResourcePulseHubRouteKeys).includes(location?.pathname);
    const isPeopleHubRoute = Object.values(PeopleHubRouteKeys).includes(location?.pathname);
    const isContractsHubRoute = Object.values(ContractsHubRouteKeys).includes(location?.pathname);
    const isTalentTransformationalHubRoute = Object.values(TalentTransformationalHubRouteKeys).includes(location?.pathname);
    const isPracticeHubRoute = Object.values(PracticeHubRouteKeys).includes(location?.pathname);
    const isFlipHubRoute = Object.values(FlipHubRouteKeys).includes(location?.pathname);
    const isImmigrationHubRoute = Object.values(ImmigrationHubRouteKeys).includes(location?.pathname);
    const isAdminHubRoute = Object.values(AdminHubRouteKeys).includes(location?.pathname);

    return (
        <>
            <ConsentForm />
            { isProcessHubRoute ? <ProcessHubNavBar hubId={1} /> : isMarketingHubRoute ? <MarketingHubNavBar hubId={3} /> : isResourcePulseHubRoute ? <ResourcePulseHubNavBar hubId={9} /> : isPeopleHubRoute ? <PeopleHubNavigationbar hubId={8}/> : isPracticeHubRoute ? <PracticeHubNavbar hubId={13}/> : isTalentTransformationalHubRoute ? <TalentTransformationalHubNavBar hubId={2}/> : isContractsHubRoute ? <ContractsHubNavBar hubId={14} /> : isFlipHubRoute ? <FlipHubNavBar hubId={16} />: isImmigrationHubRoute ? <ImmigrationHubNavBar hubId={11} /> : isAdminHubRoute ? <AdminHubNavBar hubId={19} /> : <Navbar hubId={0}/> }
            <Container fluid>
                <Main>{children}</Main>

            </Container>
            <Footer />
        </>
    );
}
